import { borderRadiusCommon } from 'components/sharedComponents/StyleConsts/styleConsts';

export const allocationMultiSelectChipsMargin = '5px 10px';
export const allocationUnselectedListItemColor = 'transparent';
export const allocationMultiSelectListItemRedious = borderRadiusCommon;
export const allocationPublicHolidayPopoverPadding = '0 15px 0 15px';
export const textFildInputPropsHeight = '100px';
export const textFildInputPropsWidth = '410px';
